<template><a class="loading" tabindex="0" @click.prevent="$emit('click')" href="."><span><slot /></span><div></div></a></template>
<script>
export default {
  name: 'loading',
  methods: {
    focus() {
      this.$el.focus()
    },
  },
}
</script>
<style lang="scss" scoped>

  @keyframes load {
    0%   { transform: rotate(0deg) scale(0.9); }
    50%  { transform: rotate(180deg) scale(0.9); }
    100% { transform: rotate(360deg) scale(0.9); }
  }

  .loading {
    margin: 2px;
    display: inline-block;
    text-align: center;
    position: relative;
    width: 20px;
    height: 20px;
    outline: none;
    > span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    > div {
      display: inline-block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      box-shadow: 0 3px 0 0 #444;
      animation: load 1s linear infinite;
    }
  }

</style>

